import gql from 'graphql-tag'

export const STOREFRONT = gql`
    fragment FragmentStorefront on Storefront {
        averageMargin
        campaignDiscount {
            id
            campaign
            percentage
            createdAt
            ends_at
            orderchampContributionPercentage
        }
        loyaltyDiscount {
            campaign
            percentage
            orderchampContributionPercentage
        }
        databaseId
        discountPercentage
        id
        isHotDeal
        isStarSeller
        minimumOrderAmount
        minimumReorderAmount
        name
        publishedAt
        realAverageReviewScore
        slug
        status
        hasDiscoveryDaysMov
        isReorderDaysParticipant
        isLowMinimumsParticipant
        isWarehouseSaleParticipant
        isOutlet
        qualifiesForFreeShippingEvent
        globalDiscount {
            id
            percentage
            customerGroupType
            campaign
        }
        specialDiscount {
            id
            percentage
            customerGroupType
            campaign
        }
        tileImage {
            x1: transformedUrl(width: 300, height: 300, method: CROP)
            x2: transformedUrl(width: 600, height: 600, method: CROP)
        }
        isBestPrice
        leadTime
        dropshippingLeadTime
        primaryCategory {
            name
        }
        primaryCountry
    }
`

export const STOREFRONT_BRANDCARD = gql`
    ${STOREFRONT}
    fragment FragmentStorefrontBrandCard on Storefront {
        ...FragmentStorefront
        listingsCount
        listings(
            first: 4
            sort: POSITION_ASC
            filters: "{\\"slider\\": true}"
        ) {
            edges {
                node {
                    title
                    image {
                        id
                        x2: transformedUrl(width: 800, height: 800)
                        x1: transformedUrl(width: 480, height: 480)
                    }
                }
            }
        }
    }
`

export const STOREFRONT_EDGES = gql`
    ${STOREFRONT_BRANDCARD}
    fragment FragmentStorefrontEdges on StorefrontConnection {
        edges {
            node {
                ...FragmentStorefrontBrandCard
            }
        }
    }
`
export const STOREFRONT_EDGES_LIGHT = gql`
    ${STOREFRONT}
    fragment FragmentStorefrontLightEdges on StorefrontConnection {
        edges {
            node {
                ...FragmentStorefront
            }
        }
    }
`
export const STOREFRONT_DISCOUNT = gql`
    fragment FragmentStorefrontGlobalDiscount on Storefront {
        campaignDiscount {
            id
            campaign
            percentage
            createdAt
            minimumOrderValue
            ends_at
            orderchampContributionPercentage
        }
        loyaltyDiscount {
            campaign
            percentage
            orderchampContributionPercentage
        }
        orderDiscounts {
            id
            name
            minimumOrderValue
            percentage
            campaign
        }
        discountPercentage
    }
`
